import * as constants from './constants';

export const robotInitialState = {
  notifications: null,
  details: {},
  notificationsCount: null,
};

const robotReducer = (state = robotInitialState, { type, payload } = {}) => {
  switch (type) {
    case constants.GET_ROBOT_DATA:
      return {
        ...state,
        notifications: { ...state.notifications, ...payload },
      };
    case constants.RESET_ROBOT_DATA:
      return {
        ...state,
        notifications: null,
      };
    case constants.SET_UNREAD_ROBOT_COUNT:
      return {
        ...state,
        notificationsCount: payload,
      };
    case constants.GET_ROBOT_DETAILS:
      return {
        ...state,
        details: { ...state.details, ...payload },
      };
    default:
      return state;
  }
};

export default robotReducer;
